// Keep local development local; deployed apps use their own /api proxy unless
// an explicit backend URL is provided at build time.
export function resolveApiBaseUrl(location, configuredUrl) {
  if (configuredUrl?.trim()) return configuredUrl.trim().replace(/\/+$/, '');
  if (['localhost', '127.0.0.1', '[::1]', '::1'].includes(location.hostname)) {
    const host = location.hostname === '::1' ? '[::1]' : location.hostname;
    return `${location.protocol}//${host}:8000/api`;
  }
  return `${location.origin}/api`;
}
